module.exports = __webpack_public_path__ + "img/11_37.70fd2fb1.png";